import { render, staticRenderFns } from "./ViewUsersCourse.vue?vue&type=template&id=81bf70ee&scoped=true"
import script from "./ViewUsersCourse.vue?vue&type=script&lang=js"
export * from "./ViewUsersCourse.vue?vue&type=script&lang=js"
import style0 from "./ViewUsersCourse.vue?vue&type=style&index=0&id=81bf70ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81bf70ee",
  null
  
)

export default component.exports